<template>
    <!--<v-container>-->
    <v-layout row wrap justify-center>
        <v-flex xs12 md6>
            <v-img v-if="store.image && baseUrl" v-bind:src="baseUrl + store.image" height="300">
                <v-layout
                        column
                        fill-height
                >
                    <v-card-title>
                        <v-btn flat @click="goBack">
                            <v-icon left small>fal fa-chevron-left</v-icon>
                            {{ $vuetify.t('$vuetify.back') }}
                        </v-btn>
                    </v-card-title>
                </v-layout>
            </v-img>

            <v-img v-else-if="store.image_location && baseUrl" v-bind:src="baseUrl + store.image_location" height="300">
                <v-layout
                        column
                        fill-height
                >
                    <v-card-title>
                        <v-btn @click="goBack">
                            <v-icon left small>fal fa-chevron-left</v-icon>
                            {{ $vuetify.t('$vuetify.back') }}
                        </v-btn>
                    </v-card-title>
                </v-layout>
            </v-img>

            <div v-else class="text-xs-left">
                <v-btn
                        flat
                        @click="goBack"
                >
                    <v-icon left small>fal fa-chevron-left</v-icon>
                    {{ $vuetify.t('$vuetify.back') }}
                </v-btn>
            </div>

        </v-flex>

        <v-flex xs12 md6 class="pl-4 pt-4">
            <div>
                <h1 class="display-1 catalog-item-title">{{ store.name }}</h1>
            </div>

            <v-card v-if="store.schedule" flat style="background: transparent">
                <v-card-text>
                    <v-icon color="primary">fal fa-clock</v-icon>
                    <span class="pl-3"> {{ store.schedule }}</span>
                </v-card-text>
            </v-card>
            <v-card v-if="store.telephone" flat style="background: transparent">
                <v-card-text>
                    <v-icon color="primary">fal fa-phone</v-icon>
                    <span class="pl-3"><a style="text-decoration: none; color: inherit;"
                                          :href="'tel:' + store.telephone">{{ store.telephone }}</a></span>
                </v-card-text>
            </v-card>

            <v-card v-if="store.email_address" flat style="background: transparent">
                <v-card-text>
                    <v-icon color="primary">fal fa-envelope</v-icon>
                    <span class="pl-3"><a style="text-decoration: none; color: inherit;"
                                          :href="'mailto:' + store.email_address">{{ store.email_address }}</a></span>
                </v-card-text>
            </v-card>

        </v-flex>

        <!--Displaying info related to the store.-->

        <!--When the store's latitude and longitude are defined, a car icon with a link to the google maps is displayed;
        with this feature the user can easily get the directions to go to the store. -->
        <v-btn v-if="store.latitude && store.longitude"
               fixed
               fab
               bottom
               right
               color="primary"
               @click="mapsSelector(store.latitude,store.longitude)">
            <v-icon>fal fa-car</v-icon>
        </v-btn>

        <v-flex xs12 class="pl-4 pr-4">
            <v-card v-if="store.address" flat style="background: transparent">
                <v-card-actions>
                    <v-card-text>
                        <v-icon color="primary">fal fa-map-marker-alt</v-icon>
                        <span class="pl-3">{{ $vuetify.t('$vuetify.address') }}</span>
                    </v-card-text>

                    <v-layout v-if="store.distance"
                              align-center
                              justify-end
                    >
                        <span class="store-address-distance subheading primary--text font-weight-bold">
                            {{ store.distance | formatDistance }} Km
                        </span>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-flex>

        <v-flex xs12 md6 class="pl-4 pr-4">
            <v-card v-if="store.address" flat style="background: transparent">

                <v-card-text>
                    <span> {{ store.address }}</span>
                    <br>
                    <span class="grey--text">{{ store.postal_code }} {{ store.location }}</span>
                    <br>
                    <span class="grey--text">{{ store.country }}</span>
                </v-card-text>
            </v-card>
        </v-flex>

        <v-flex xs12 md6 class="pl-4 pr-4 pb-5">
            <v-card v-if="store.image && store.image_location && baseUrl" flat style="background: transparent">
                <v-img v-if="store.image && store.image_location && baseUrl" v-bind:src="baseUrl + store.image_location"
                       height="200px">
                </v-img>
            </v-card>
        </v-flex>
    </v-layout>
    <!--</v-container>-->
</template>

<script>
import {getDistanceFromLatLonInKm} from '../../_helpers'
import {mapGetters} from "vuex";


export default {
    name: "StoreDetail",
    data() {
        return {
            location: '',
        }
    },
    computed: {
        store() {
            let id = parseInt(this.$route.params.id);
            let store = this.$parent.getStoreById(id);
            if (store.latitude && store.longitude) {
                store.distance = getDistanceFromLatLonInKm(store.latitude, store.longitude, this.location.latitude, this.location.longitude);
            }

            return store
        },
        ...mapGetters({
            baseUrl: 'configs/apiImgBaseUrl',
        }),
    },
    methods: {
        mapsSelector(lat, long) {
            /* if we're on iOS, open in Apple Maps */
            var ua = navigator.userAgent.toLowerCase();
            var pf = navigator.platform;
            if (ua.indexOf('safari') !== -1 && ((pf.indexOf("iPhone") !== -1) || (pf.indexOf("iPod") !== -1) || (pf.indexOf("iPad") !== -1)))
                window.open("maps://maps.google.com/maps?daddr=" + lat + "," + long + "&amp;ll=");
            else /* else use Google */
                window.open("https://maps.google.com/maps?daddr=" + lat + "," + long + "&amp;ll=");
        },
        goBack() {
            this.$router.push({name: "stores-list"});
        },
    },
    // Vue.js allows you to define filters that can be used to apply common text formatting.
    // Filters are usable in two places: mustache interpolations
    filters: {
        formatDistance(value) {
            return (value / 1).toFixed(1);
        }
    },
    mounted() {
        //https://developer.mozilla.org/pt-BR/docs/Web/API/Position
        //Getting user's current geo location
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                this.location = position.coords;
            })
        }
    },
}
</script>

<style scoped>

</style>